export default "__VITE_ASSET__3Q1x9hPl__"